module.exports = __webpack_public_path__ + "img/base_hiver_ski_alpin.e6dc29d3.svg";